/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import jQuery from 'jquery';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';
import CustomHtml from '@/common/components/CustomHtmlSlot';

import ModalHeader from '../common/modal/header';
import ModalFooter from '../common/modal/footer';

import Description from './description';
import Quantity from './quantity';
import Sizes from './sizes';
import ModifierBrowser from './modifier-browser';
import Comment from './comment';

const { UI } = Mobi2Go;
const { classNames } = Mobi2Go.helpers;

class ProductEditor extends React.Component {
    group_selection_limit_warning_count = {};

    group_selection_requirement_warning_count = {};

    static propTypes = {
        product: PropTypes.object,
        t: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        scrollModalElementIntoView: PropTypes.func.isRequired,
        footerElementOverride: PropTypes.object,
    };

    static defaultProps = {
        product: null,
        footerElementOverride: null
    };

    constructor(props) {
        super(props);

        this.state = {
            name: '',
            description: '',
            image_src: null,
            quantity: 1,
            for_name: '',
            allow_comment: false,
            comment: '',
            tags: [],
            is_in_order: false,
            size: null,
            size_options: [],
            size_modifier_group: null,
            modifier_groups: [],
            total: '',
        };
    }

    componentDidMount() {
        const { product } = this.props;
        if (product) {
            this.setProduct(product);
        }
    }

    componentDidUpdate() {
        const { product } = this.props;
        if(product && this.product && product.cid !== this.product.cid) {
            this.setProduct(product);
        }
    }

    setProduct = order_product => {
        const event_bindings = {
            updateSize: this.updateState,
            updateTotal: this.updateState,
            updateQuantity: this.updateState,
            updateComment: this.updateState,
            updateForName: this.updateState,
            updateModifierState: this.updateState,
            updateModifierSelection: this.updateState,
            updateModifierOutOfStock: this.updateState,
            updateModifierVisibility: this.updateState,
            updateModifierGroupCollapsed: this.updateState,
            updateModifierGroupVisibility: this.updateState,
            updateModifierGroupSelectionLimit: this.updateState,
            updateModifierGroupSelectionRequirement: this.updateState,
            updateModifierGroupRestriction: this.updateState,
            updateGroupSelectionCount: this.updateState,
            updateGroupSelectionLimitMet: this.updateState,
            groupSelectionLimitWarning: this.groupSelectionLimitWarning,
            selectionLimitWarning: this.selectionLimitWarning,
            updateMenuRestrictions: this.updateState,
        };

        if (this.product) {
            this.product.unbind(event_bindings);
        }

        this.product = order_product;
        this.product.bind(event_bindings);
        this.updateState();

        this.setState({ is_in_order: this.product.isInOrder() });
    };

    updateState = () => {
        const { product } = this;
        const { menu_product } = product;
        const size_modifier_group = menu_product.getSizeModifierGroup();
        const modifier_groups = product.modifier_groups.filter(
            g => g.visible && !g.is_restricted
        );
        const new_state = {
            name: menu_product.name,
            description: menu_product.description,
            image_src: menu_product.image_src,
            quantity: product.quantity,
            for_name: product.for_name,
            hide_quantity_selector: menu_product.shouldHideQuantitySelector(),
            size: product.size && {
                id: product.size.menu_modifier.id,
                name: product.size.menu_modifier.name,
            },
            size_options: product.getAvailableSizeOptions().map(size => ({
                id: size.menu_modifier.id,
                name: size.menu_modifier.name,
                backend_name: size.menu_modifier.backend_name,
                out_of_stock: size.out_of_stock,
                visible: size.visible,
                price: size.getDisplayPrice(),
            })),
            size_modifier_group: size_modifier_group && {
                id: size_modifier_group.id,
                name: size_modifier_group.name,
                backend_name: size_modifier_group.backend_name,
            },
            modifier_groups: modifier_groups.map(group => ({
                id: group.menu_modifier_group.id,
                name: group.menu_modifier_group.name,
                backend_name: group.menu_modifier_group.backend_name,
                visible: group.visible,
                collapsed: group.collapsed,
                is_restricted: group.is_restricted,
                tags: group.menu_modifier_group.tags,
                selection_count: group.selection_count,
                selection_limit: group.selection_limit,
                selection_limit_met: group.selection_limit_met,
                selection_requirement: group.selection_requirement,
                selection_requirement_met: group.selection_requirement_met,
                modifiers: group.modifiers
                    .filter(g => g.visible)
                    .map(modifier => ({
                        id: modifier.menu_modifier.id,
                        name: modifier.menu_modifier.name,
                        backend_name: modifier.menu_modifier.backend_name,
                        description: modifier.menu_modifier.description,
                        image_src: null,
                        price: modifier.price.toFloat() ? modifier.price : '',
                        is_default: modifier.is_default,
                        selection_state: modifier.selection_state,
                        quantity: modifier.quantity,
                        quantity_limit: modifier.menu_modifier.quantity_limit,
                        visible: modifier.visible,
                        out_of_stock: modifier.out_of_stock,
                        type: modifier.menu_modifier.type,
                        tags: modifier.menu_modifier.tags,
                        can_quantity_be_increased: modifier.canQuantityBeIncreased(),
                    })),
                sub_products: group
                    .getSubProductQuantities()
                    .map(({ menu_product: sp_menu_product, quantity }) => ({
                        menu_product: {
                            id: sp_menu_product.id,
                            name: sp_menu_product.name,
                            backend_name: sp_menu_product.backend_name,
                            description: sp_menu_product.description,
                            image_src: sp_menu_product.image_src,
                            price: sp_menu_product.price,
                            display_price: sp_menu_product.display_price,
                            tags: sp_menu_product.tags,
                            modifier_groups: sp_menu_product.modifier_groups,
                            getPrice: sp_menu_product.getPrice,
                            getSizeOptions: sp_menu_product.getSizeOptions,
                            getProperty: sp_menu_product.getProperty,
                            hasTag: sp_menu_product.hasTag,
                            getModifierGroups: sp_menu_product.getModifierGroups,
                            getSizeModifierGroup: sp_menu_product.getSizeModifierGroup,
                        },
                        quantity,
                    })),
            })),
            allow_comment: menu_product.allow_comment,
            comment: product.comment,
            price: product.list_price,
            total: product.list_total,
            tags: menu_product.tags,
        };

        this.setState(new_state);
    };

    onQuantityChange = quantity => {
        this.product.setQuantity(quantity);
    };

    onSizeChange = size_modifier_id => {
        this.product.setSizeById(size_modifier_id);
    };

    onCommentChange = comment => {
        this.product.setComment(comment);
    };

    onForNameChange = name => {
        this.product.setForName(name);
    };

    onModifierGroupNavClick = modifier_group => {
        this.product
            .getModifierGroupByMenuId(modifier_group.id)
            .setCollapsed(false);
    };

    onModifierGroupHeadingClick = modifier_group => {
        const modifierGroup = this.product.getModifierGroupByMenuId(
            modifier_group.id
        );
        if (modifierGroup.getCollapsed()) {
            modifierGroup.setCollapsed(false);
        } else {
            modifierGroup.setCollapsed(true);
        }
        this.product.trigger('modifierGroupHeadingClick', modifier_group);
    };

    onModifierClick = modifier => {
        this.product.toggleModifierById(modifier.id);
    };

    onModifierQuantityChange = (modifier, quantity) => {
        this.product.setModifierQuantityById(modifier.id, quantity);
    };

    onSubProductQuantityAdd = (menu_product, modifier_group) => {
        this.product.addSubProductById(menu_product.id, modifier_group.id);
    };

    onSubProductQuantityRemove = (menu_product, modifier_group) => {
        this.product.removeFirstSubProductById(
            menu_product.id,
            modifier_group.id
        );
    };

    onSubProductEdit = (menu_product, modifier_group) => {
        const modifier_group_instance = this.product.getModifierGroupByMenuId(
            modifier_group.id
        );
        const sub_products_to_edit = modifier_group_instance
            .getSubProducts()
            .filter(sb => sb.menu_product.id === menu_product.id);

        UI.trigger('editSubProducts', {
            products: sub_products_to_edit,
            onComplete: () => {},
        });
    };

    onRemove = () => {
        const { closeModal } = this.props;
        this.product.removeFromOrder();
        closeModal();
    };

    groupSelectionLimitWarning = modifier_group => {
        const { id } = modifier_group.menu_modifier_group;
        const group = modifier_group.menu_modifier_group;
        const limit_badge = jQuery(`[data-modifier-group="${id}"]`).find(
            '[data-limit-badge]'
        )[0];
        let warning_alert_threshold = 5;

        if (!(id in this.group_selection_limit_warning_count)) {
            this.group_selection_limit_warning_count[id] = 0;
        }

        this.group_selection_limit_warning_count[id] += 1;
        const warning_count = this.group_selection_limit_warning_count[id];

        if (this.is_ie || this.product.isSubProduct()) {
            warning_alert_threshold = 0;
        }

        if (warning_count >= warning_alert_threshold) {
            const { t } = this.props;
            UI.centeredAlert({
                id: 'group-selection-limit-warning',
                title: t('group_selection_limit_title'),
                body: t('group_selection_limit_body', {
                    selection_limit: group.selection_limit,
                    group_name: group.name,
                }),
                temp: true,
            });
            this.group_selection_limit_warning_count[
                id
            ] -= warning_alert_threshold;
        }
        if (limit_badge) {
            const scroll_offset = -15;
            const { scrollModalElementIntoView } = this.props;
            scrollModalElementIntoView(
                limit_badge,
                scroll_offset,
                false,
                () => {
                    UI.helpers.setAnimation(
                        limit_badge,
                        'modifier-group-selection-warning',
                        true
                    );
                }
            );
        }
    };

    groupSelectionRequirementWarning = modifier_group => {
        const { id } = modifier_group.menu_modifier_group;
        const { menu_modifier_group } = modifier_group;
        const requirement_badge = jQuery(`[data-modifier-group="${id}"]`).find(
            '[data-requirement-badge]'
        )[0];
        let warning_alert_threshold = 3;

        if (!(id in this.group_selection_requirement_warning_count)) {
            this.group_selection_requirement_warning_count[id] = 0;
        }

        this.group_selection_requirement_warning_count[id] += 1;
        const warning_count = this.group_selection_requirement_warning_count[
            id
        ];

        if (this.is_ie || this.product.isSubProduct()) {
            warning_alert_threshold = 0;
        }

        if (warning_count >= warning_alert_threshold) {
            const { t } = this.props;
            UI.centeredAlert({
                id: 'selection-requirement-warning',
                title: t('group_selection_required_title', {
                    group_name: menu_modifier_group.name,
                }),
                body: t('group_selection_required_body', {
                    count: menu_modifier_group.selection_requirement,
                    group_name: menu_modifier_group.name,
                }),
                temp: true,
            });

            this.group_selection_requirement_warning_count[
                id
            ] -= warning_alert_threshold;
        }

        if (requirement_badge) {
            const scroll_offset = -15;
            const { scrollModalElementIntoView } = this.props;
            scrollModalElementIntoView(
                requirement_badge,
                scroll_offset,
                false,
                () => {
                    UI.helpers.setAnimation(
                        requirement_badge,
                        'modifier-group-selection-warning',
                        true
                    );
                }
            );
        }
    };

    selectionLimitWarning = () => {
        const { t } = this.props;
        UI.centeredAlert({
            id: 'selection-limit-warning',
            title: t('selection_limit_title'),
            body: t('selection_limit_body', {
                count: this.product.menu_product.modifier_selection_limit,
            }),
            temp: true,
        });
    };

    onAddButtonClick = () => {
        const unmet_selection_requirement = this.product.getUnmetSelectionRequirementModifierGroup();
        if (unmet_selection_requirement) {
            this.groupSelectionRequirementWarning(unmet_selection_requirement);
            return;
        }

        // Resolve sub product modifier group requirements
        const unresolved_sub_products = this.product.getSubProducts().filter((sb => {
            return !!sb.getUnmetSelectionRequirementModifierGroup();
        }));

        if(unresolved_sub_products.length) {
            UI.trigger('editSubProducts', {
                products: unresolved_sub_products,
                onComplete: () => {
                    this.onAddButtonClick();
                }
            });
            return;
        }

        const { closeModal } = this.props;
        closeModal();

        if (!this.product.isInOrder()) {
            this.product.addToOrder();
        }
    };

    onCloseButtonClick = () => {
        const { closeModal } = this.props;
        closeModal();
    };

    renderFooter = () => {
        const {
            hide_quantity_selector,
            quantity,
            is_in_order,
            total,
            for_name,
        } = this.state;
        const { footerElementOverride, t } = this.props;

        if(footerElementOverride) {
            return footerElementOverride;
        }

        return (
            <>
                <ModalFooter.Left>
                        {!hide_quantity_selector && (
                            <Quantity
                                onChange={this.onQuantityChange}
                                quantity={quantity}
                                onRemove={this.onRemove}
                                is_in_order={is_in_order}
                            />
                        )}
                        <div className="m2g-product-editor-price">
                            {t('common:price', {
                                price: total,
                            })}
                        </div>
                    </ModalFooter.Left>
                    <ModalFooter.Right>
                        <div
                            className="m2g-product-editor-for-name m2g-input-container"
                            data-icon-before
                        >
                            <input
                                className="m2g-product-editor-for-name-input m2g-input m2g-form-element--full-width"
                                data-for-name
                                type="text"
                                onChange={e =>
                                    this.onForNameChange(e.target.value)
                                }
                                placeholder={t('for_name')}
                                value={for_name}
                            />
                            <span className="m2g-icon m2g-icon--user" />
                        </div>
                        {is_in_order && (
                            <button
                                type="button"
                                className="m2g-product-editor-remove-button m2g-button"
                                onClick={this.onRemove}
                            >
                                {t('remove')}
                            </button>
                        )}
                        {is_in_order && (
                            <button
                                type="button"
                                className="m2g-product-editor-save-button m2g-button m2g-button--primary"
                                onClick={this.onAddButtonClick}
                                data-save
                            >
                                {t('done')}
                            </button>
                        )}
                        {!is_in_order && (
                            <button
                                type="button"
                                className="m2g-product-editor-add-button m2g-button m2g-button--primary"
                                onClick={this.onAddButtonClick}
                                data-save
                            >
                                <span className="m2g-product-editor-add-button-text">
                                    {t('add')}
                                </span>
                            </button>
                        )}
                    </ModalFooter.Right>
            </>
        );
    };

    render() {
        const {
            name,
            modifier_groups,
            image_src,
            description,
            tags,
            size_options,
            size,
            size_modifier_group,
            allow_comment,
            comment,
        } = this.state;

        return (
            <div>
                <CustomHtml slot="desktop-product-editor-heading-above" />
                <ModalHeader
                    onClose={this.onCloseButtonClick}
                    headerText={name}
                    className="m2g-product-editor-product-name"
                />
                <CustomHtml slot="desktop-product-editor-heading-below" />

                <div
                    className={classNames('m2g-modal-body', {
                        'm2g-product-editor-body--with-modifiers': !!Object.keys(
                            modifier_groups
                        ).length,
                    })}
                >
                    <Description
                        image_src={image_src}
                        description={description}
                    />

                    <div className="m2g-product-editor-tags">
                        {tags.map(tag => (
                            <div
                                key={tag}
                                className="m2g-tag m2g-product-editor-tag"
                                title={tag}
                                data-tag={tag}
                            />
                        ))}
                    </div>

                    {size_options.length > 0 && (
                        <div className="m2g-product-editor-settings m2g-well">
                            {Object.keys(size_options).length !== 0 && (
                                <Sizes
                                    onChange={this.onSizeChange}
                                    size={size}
                                    size_options={size_options}
                                    size_modifier_group={size_modifier_group}
                                    display_as_checkboxes={this.product.menu_product.hasTag(
                                        'display-size-options-as-checkboxes'
                                    )}
                                />
                            )}
                        </div>
                    )}

                    <ModifierBrowser
                        onModifierGroupHeadingClick={
                            this.onModifierGroupHeadingClick
                        }
                        onModifierGroupNavClick={this.onModifierGroupNavClick}
                        onModifierClick={this.onModifierClick}
                        onModifierQuantityChange={this.onModifierQuantityChange}
                        onSubProductQuantityAdd={this.onSubProductQuantityAdd}
                        onSubProductQuantityRemove={
                            this.onSubProductQuantityRemove
                        }
                        onSubProductEdit={this.onSubProductEdit}
                        modifier_groups={modifier_groups}
                    />

                    {allow_comment && (
                        <Comment
                            onChange={this.onCommentChange}
                            comment={comment}
                        />
                    )}

                    <div
                        data-error
                        className="m2g-modal-alert m2g-alert m2g-hidden"
                    />
                </div>

                <ModalFooter>
                    {this.renderFooter()}
                </ModalFooter>
            </div>
        );
    }
}

export default forwardRefWithTranslation('product-editor')(ProductEditor);
